// Loading-fallback для guards / useOnboardingState. Минимальная версия —
// дизайн-вариант (skeleton / spinner) уточнится в c2 при создании AppShell.

export function FullScreenSpinner() {
  return (
    <div
      role="status"
      aria-label="Загрузка"
      className="mx-auto flex min-h-screen max-w-md items-center justify-center bg-background"
    >
      <span className="text-sm text-muted-foreground">Загрузка…</span>
    </div>
  );
}
